(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frp-slideshow-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('frp-slideshow-video')) {
    customElements.define('frp-slideshow-video', class extends HTMLElement {
      connectedCallback() {
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.update = () => {
          this.video?.pause();
          this.video?.remove();
          const template = this.querySelector(this.mobile.matches ? '[data-mobile]' : '[data-desktop]');
          this.append(template.content.cloneNode(true));
          const video = this.querySelector('video');
          this.video = video;
          if (video) {
            video.muted = true;
            // 播起来之前透明，露出下面的首帧图；否则视频自带的 _small 缩略图 poster 会先糊一下
            video.addEventListener('playing', () => video.classList.add('is-playing'), {once: true});
          }
          this.sync();
        };
        this.sync = () => {
          if (!this.video) return;
          if (this.visible && !document.hidden && !this.motion.matches) {
            this.video.play().catch(() => this.armGesture()); // FRP:VIDEO-GESTURE-FALLBACK
          } else this.video.pause();
        };
        // Autoplay refused (iOS Low Power Mode, in-app browsers): retry on the first tap / click / key.
        this.armGesture = () => {
          if (this.retry) return;
          this.retry = () => { this.disarmGesture(); this.sync(); };
          ['touchend', 'click', 'keydown'].forEach(t => document.addEventListener(t, this.retry, {capture: true, passive: true}));
        };
        this.disarmGesture = () => {
          if (!this.retry) return;
          ['touchend', 'click', 'keydown'].forEach(t => document.removeEventListener(t, this.retry, true));
          this.retry = null;
        };
        // WeChat blocks muted autoplay unless play() runs inside a WeixinJSBridge callback.
        const wx = () => window.WeixinJSBridge && window.WeixinJSBridge.invoke('getNetworkType', {}, () => this.sync());
        if (window.WeixinJSBridge) wx(); else document.addEventListener('WeixinJSBridgeReady', wx, {once: true});
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
          this.sync();
        }, {threshold: [0, 0.25]});
        this.mobile.addEventListener('change', this.update);
        this.motion.addEventListener('change', this.sync);
        document.addEventListener('visibilitychange', this.sync);
        this.update();
        this.observer.observe(this.parentElement);
      }
      disconnectedCallback() {
        this.video?.pause();
        this.disarmGesture?.();
        this.observer?.disconnect();
        this.mobile?.removeEventListener('change', this.update);
        this.motion?.removeEventListener('change', this.sync);
        document.removeEventListener('visibilitychange', this.sync);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
